import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { twoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";

twoButtonModalStyles.modal = mergeToNew(twoButtonModalStyles.modal, {
    sizeVariant: "large",
});
